import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "header" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_band = _resolveComponent("header-band")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bands, (band, position) => {
      return (_openBlock(), _createBlock(_component_header_band, {
        key: position,
        letter: band.letter,
        position: position,
        color: band.color,
        minimized: _ctx.headerMinimized
      }, null, 8, ["letter", "position", "color", "minimized"]))
    }), 128))
  ]))
}